import { createAsyncTypes } from 'utils/ActionCreator'

export const INSIGHT_WIDGET_REQUEST_ASYNC = createAsyncTypes(
  'INSIGHT_WIDGET_REQUEST_ASYNC',
  'IronScales/Dashboard/Home/InsightWidget'
)
